import axios from 'axios';
import AppConfig from "../AppConfig";

let URL = AppConfig.HOST_API();

export default {

    getTrasy() {
        return axios({
            method: 'GET',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/search/trasy' + AppConfig.V_LOG(),
        });
    },

    getKursy(idTr, data) {
        return axios({
            method: 'GET',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/search/wariantTrasy/kusy?data=' + data + '&idTr=' + idTr + AppConfig.V_LOG_SECOND_PARAM(),
        });
    },

    getPrzystanki(idKu) {
        return axios({
            method: 'GET',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/search/wariantTrasy/przystanki/' + idKu + AppConfig.V_LOG(),
        });
    },

}



// WEBPACK FOOTER //
// ./src/components/rozklad/RozkladService.js